import TagsGateway from './TagsGateway'
import TagsModel from './TagsModel'
import TagsListModel from './TagsListModel'
import ManagerModel from './ManagerModel'
import employeeModel from '../employees/EmployeeModel'

export default class TagsService {
  constructor (tagsGateway) {
    this.TagsGateway = tagsGateway || new TagsGateway()

    this.getTag = this.getTag.bind(this)
    this.getTags = this.getTags.bind(this)
    this.updateTag = this.updateTag.bind(this)
    this.deleteTag = this.deleteTag.bind(this)
    this.addTag = this.addTag.bind(this)
    this.activateTag = this.activateTag.bind(this)
    this.getManagersByTagId = this.getManagersByTagId.bind(this)
    this.getEmployeesByTagId = this.getEmployeesByTagId.bind(this)
    this.getDeletedTags = this.getDeletedTags.bind(this)
  }

  getDeletedTags () {
    return this.TagsGateway
    .getDeletedTags()
    .then(response => response)
  }

  activateTag (params) {
    return this.TagsGateway
    .activateTag(params)
    .then(response => new TagsModel(response))
  }

  getTag (params) {
    return this.TagsGateway
    .getTag(params)
    .then(response => new TagsModel(response))
  }

  getTags () {
    return this.TagsGateway
      .getTags()
      .then(response => new TagsListModel(response))
  }

  getManagersByTagId (params) {
    return this.TagsGateway
      .getManagersByTagId(params)
      .then(response => response.map(item => new ManagerModel(item)))
  }

  getEmployeesByTagId (params) {
    return this.TagsGateway
    .getEmployeesByTagId(params)
    .then(response => response.map(item => employeeModel(item)))
  }

  updateTag (query) {
    return this.TagsGateway
      .updateTag(query)
      .then(response => new TagsModel(response))
  }

  deleteTag (params) {
    return this.TagsGateway
      .deleteTag(params)
      .then(response => new TagsModel(response))
  }

  addTag (query) {
    return this.TagsGateway
      .addTag(query)
      .then(response => new TagsModel(response))
  }
}



// WEBPACK FOOTER //
// ./src/api/tags/TagsService.js